import ServiceBase from "@app/shared/serviceBase";
import { PgrConfidenceTierDefinition } from "@app/shared/confidence-tier/pgrConfidenceTierDefinition";

export default class PgrConfidenceTierService extends ServiceBase {
  public async getConfidenceTierDefinitions(signal?: AbortSignal): Promise<PgrConfidenceTierDefinition[]> {
    return this.makeGet<PgrConfidenceTierDefinition[]>("pgr/confidence-tier-definitions", null, undefined, false, undefined, signal);
  }
}
